export default __webpack_public_path__ + "static/MineralSwimV2_BENEFITS_pH_Balancing_1920x1000-2b04b2d8cac871c6d9b207ef9f21c746.jpg";